/**
 * scroll-reveal.js — A Granel Madrid
 * MOTOR ÚNICO de reveal-on-scroll (consolida los antiguos
 * granel-reveal.js y granel-animations.js — auditoría 2026-06).
 *
 * Un solo IntersectionObserver para los 3 sistemas:
 *  A) data-gr-reveal / data-gr-stagger  → clase `gr-visible` (motion-granel.css)
 *  B) data-gr-anim (atributo en Liquid) → clase `gr-visible` (sin CSS asociado hoy)
 *  C) data-gr-rv + html.gr-reveal-on    → clase `gr-in` (custom-granel.css)
 *
 * Seguridad:
 *  · prefers-reduced-motion: no se añaden atributos ni .gr-reveal-on →
 *    las reglas CSS nunca aplican y nada queda oculto; los [data-gr-anim]
 *    reciben gr-visible de inmediato (comportamiento legado).
 *  · Sin IntersectionObserver: todo visible.
 *  · El sistema C solo oculta elementos BAJO el pliegue (no daña LCP),
 *    excluye header/footer/drawers/fixed/sticky y va en try/catch:
 *    ante cualquier fallo se retira .gr-reveal-on (todo visible).
 */
(function () {
  'use strict';

  var VISIBLE = 'gr-visible';
  var html = document.documentElement;

  var reduce = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Sin animaciones: revelar [data-gr-anim] al instante y salir.
     El resto del CSS está gateado a atributos/clases que nunca se añaden. */
  if (reduce || !('IntersectionObserver' in window)) {
    var flash = function () {
      document.querySelectorAll('[data-gr-anim]').forEach(function (el) {
        el.classList.add(VISIBLE);
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', flash);
    } else {
      flash();
    }
    return;
  }

  /* ── Sistema A: contenedores stagger + individuales (gr-visible) ── */
  var STAGGER_CONTAINERS = [
    '.product-grid',
    '.cat-grid-all__grid',
    '.cg__grid',
    '.multicolumn__grid',
  ];

  var INDIVIDUAL = [
    '.collection-seo-intro',
    '.pd__card',
    '.blog-post-card',
    '[class*="blog-posts-list"] article',
    '.multicolumn__item',
    '.icon-with-text__item',
  ];

  /* ── Sistema C: reveal tipo app (gr-in), solo bajo el pliegue ── */
  var RV_SEL = [
    'h2', '.section-header__title',
    '.product-card', '.agp-rcard', '.agp-review', '.ag-card', '.blog-card-premium',
    '.agp-fact', '.agp-trust', '.agx', '.agcalc', '.agp-details', '.agp-gallery__main',
    '.agnews', '.agp-info__head', '.agp-reviews__summary'
  ].join(',');

  var RV_EXCLUDE = '.shopify-section-group-header-group, .shopify-section-group-footer-group,' +
                   ' .cart-drawer, .menu-drawer, dialog, [data-agsticky], #fstoast, .agpop, header';

  var seen = new WeakSet();

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        if (el.hasAttribute('data-gr-rv')) el.classList.add('gr-in');
        if (
          el.hasAttribute('data-gr-reveal') ||
          el.hasAttribute('data-gr-stagger') ||
          el.hasAttribute('data-gr-anim')
        ) {
          el.classList.add(VISIBLE);
        }
        observer.unobserve(el);
      });
    },
    { threshold: 0.06, rootMargin: '0px 0px 8% 0px' } // precarga: revela antes de entrar (scroll rapido)
  );

  function watch(el) {
    if (seen.has(el)) return;
    seen.add(el);
    observer.observe(el);
  }

  /* Red de seguridad del sistema C: revela cualquier item ya pasado
     (saltos, anclas, recarga a media página). Registrada una sola vez. */
  var ticking = false;
  function revealPassed() {
    ticking = false;
    var h = window.innerHeight || 800;
    document.querySelectorAll('[data-gr-rv]:not(.gr-in)').forEach(function (el) {
      if (el.getBoundingClientRect().top < h * 0.98) {
        el.classList.add('gr-in');
        observer.unobserve(el);
      }
    });
  }
  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(revealPassed); }
  }

  function initReveal() {
    /* A1. Stagger containers — primero, para que closest() funcione */
    STAGGER_CONTAINERS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (!el.hasAttribute('data-gr-stagger')) {
          el.setAttribute('data-gr-stagger', '');
        }
        watch(el);
      });
    });

    /* A2. Elementos individuales explícitos en HTML */
    document.querySelectorAll('[data-gr-reveal]').forEach(watch);

    /* A3. Elementos individuales auto-detectados */
    INDIVIDUAL.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.closest('[data-gr-stagger]')) return;
        el.setAttribute('data-gr-reveal', '');
        watch(el);
      });
    });

    /* B. [data-gr-anim]: lo visible al cargar se revela sin esperar al IO */
    document.querySelectorAll('[data-gr-anim]').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        el.classList.add(VISIBLE);
      } else {
        watch(el);
      }
    });
  }

  var rvStarted = false;
  function initRv() {
    try {
      var nodes = [].slice.call(document.querySelectorAll(RV_SEL)).filter(function (el) {
        if (el.closest(RV_EXCLUDE)) return false;
        var cs = getComputedStyle(el);
        if (cs.position === 'fixed' || cs.position === 'sticky') return false;
        return true;
      });
      if (!nodes.length) return;

      html.classList.add('gr-reveal-on');

      var vh = window.innerHeight || 800;
      nodes.forEach(function (el) {
        /* Solo lo que está bajo el pliegue se anima; lo visible no se toca. */
        if (el.getBoundingClientRect().top >= vh * 0.92) {
          el.setAttribute('data-gr-rv', '');
          watch(el);
        }
      });

      if (!rvStarted) {
        rvStarted = true;
        window.addEventListener('scroll', onScroll, { passive: true });
        setTimeout(revealPassed, 400); /* por si la página carga ya desplazada */
      }
    } catch (err) {
      html.classList.remove('gr-reveal-on'); /* seguridad: mostrar todo */
    }
  }

  function init() {
    initReveal();
    initRv();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Editor de temas / secciones recargadas por AJAX */
  document.addEventListener('shopify:section:load', initReveal);
})();
